var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 32.5L24 24.5L16 32.5",
    stroke: "#20996B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 24.5V42.5",
    stroke: "#20996B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7799 37.28C42.7306 36.2165 44.2716 34.5337 45.1597 32.4972C46.0477 30.4607 46.2323 28.1864 45.6843 26.0334C45.1363 23.8803 43.8869 21.971 42.1333 20.6069C40.3796 19.2427 38.2216 18.5014 35.9999 18.5H33.4799C32.8745 16.1585 31.7462 13.9846 30.1798 12.142C28.6134 10.2993 26.6496 8.83567 24.4361 7.86118C22.2226 6.8867 19.817 6.42669 17.4002 6.51573C14.9833 6.60478 12.6181 7.24057 10.4823 8.3753C8.34649 9.51003 6.49574 11.1142 5.06916 13.0671C3.64259 15.0201 2.6773 17.271 2.24588 19.6508C1.81446 22.0305 1.92813 24.477 2.57835 26.8065C3.22856 29.136 4.3984 31.2877 5.99992 33.1",
    stroke: "#20996B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 32.5L24 24.5L16 32.5",
    stroke: "#20996B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.0f3699e7ce544cec7821f8fd30c8545e.svg";
export { ForwardRef as ReactComponent };